import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Select from "react-select";
import BsModal from "../../Misc/BsModal";
import SuperSelect from "../../Misc/SuperSelect";
import EssenceReferenceSchedulerEdit from "../../Essence/EssenceReferenceSchedulerEdit";
import DtPicker from "../../Misc/DtPicker";
import ModelPicker from "../../Misc/ModelPicker";
import Modal from "../../Misc/Modal";
import ElasticInput from "../../Misc/ElasticInput";

export default class MaintReq extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      lines: [],
      measure: [],
      models: [],
      pending: false,
      descriptionOpen: false,
      data: props.data || {},
      dataChanged: false,

      modelPickShow: false,
      modelPickIdx: false,
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.itemId !== this.props.itemId ||
      prevProps.elementId !== this.props.elementId
    ) {
      this.load();
    }
    if (prevProps.show !== this.props.show) {
      this.setState({ descriptionOpen: false });
    }
  }

  onDataChange = (key, value) => {
    this.setState((state) => {
      let data = state.data;
      data[key] = value;
      return { data, dataChanged: true };
    });
  };

  onLineChange = (idx, key, value) => {
    let { lines } = this.state;
    lines[idx][key] = value;
    this.setState({ lines });
  };

  onCreateModel = async (model) => {
    this.setState(
      (state) => {
        let { models } = state;
        models[model.id] = { label: model.label };
        return { models };
      },
      () => this.onLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let models = await this.context.api.qo("/model/list", {
      reclimit: 0,
      fields: ["id", "label"],
    });
    let measure = await this.context.api.qr("/measure/list");
    this.setState({ pending: false, measure, models });
  };

  rowAdd = (idx) => {
    let { lines } = this.state;
    let index = idx || lines.length;
    lines.splice(index, 0, {});
    this.setState({ lines });
  };

  rowRemove = (idx) => {
    let { lines } = this.state;
    lines.splice(idx, 1);
    this.setState({ lines });
  };

  load = async () => {
    this.setState({ pending: true });
    let lines = await this.context.api.qa("/maintenance/requirement/list", {
      filter: {
        maintenanceitemid: this.props.itemId,
      },
      orderby: ["sequence"],
    });
    this.setState({
      pending: false,
      descriptionOpen: false,
      lines: lines || [],
      data: this.props.data || {},
      dataChanged: false,
    });
  };

  save = async () => {
    let items = [];
    let { lines, data } = this.state;

    this.setState({ pending: true });

    lines.forEach((line) => {
      items.push({
        modelid: line.modelid,
        measureid: line.measureid,
        volume: parseInt(line.volume),
        description: line.description,
        name: line.name,
      });
    });

    let itemsResult = await this.context.api.q("/maintenance/requirement", {
      maintenanceitem: this.props.itemId,
      requirements: items
    });

    let dataResult = await this.context.api.q("/maintenance/item/set", {
      id: this.props.itemId,
      element: this.props.elementId,
      metervalue: data.metervalue || 0,
      meterperiod: data.meterperiod || 0,
      scheduler: data.schedulerid || this.context.api.nullUuid,
      daterun: data.daterun || this.context.api.minDate,
      sequence: data.sequence
    });

    if (itemsResult !== false && dataResult !== false) {
      this.context.toast("Изменения сохранены", "success");
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
    if (this.state.dataChanged && this.props.onAfterSave) {
      this.props.onAfterSave();
    }
    this.load();
  };

  descriptionToggle = (idx) => {
    this.setState((state) => {
      let descriptionOpen = state.descriptionOpen === idx ? false : idx;
      return { descriptionOpen };
    });
  };

  getModelLabel = (id) => {
    let result = "";
    if (this.state.models[id]) {
      result = `${this.state.models[id].label}`;
    }
    return result;
  };

  onModelPickOpen = (idx) => {
    this.setState({ modelPickShow: true, modelPickIdx: idx });
  };

  onModelPickClose = () => {
    this.setState({ modelPickShow: false });
  };

  onModelPick = (model) => {
    this.onLineChange(this.state.modelPickIdx, "modelid", model.id);
  };

  render() {
    const { pending, lines, descriptionOpen, data } = this.state;
    const { show, onClose } = this.props;
    return (
      <>
        <Modal xl show={show} onClose={onClose}>
          <ModelPicker
            onModelPick={this.onModelPick}
            onClose={this.onModelPickClose}
            onCreate={this.onCreateModel}
            show={this.state.modelPickShow}
            allowCreate
            keepModal
          />
          <h5 className="mb-4">
            ТО
            <span className="text-muted mx-2">{this.props.itemName}</span> для
            <span className="text-muted  mx-2">{this.props.elementName}</span>
          </h5>

          <Blocker on={pending}>
            <div className="mb-4 p-5 bg-light">
              <div className="row">
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>
                      Период ТО
                      <br /> в часах наработки
                    </label>
                    <input
                      id="metervalue"
                      value={data.meterperiod || ""}
                      onChange={(e) =>
                        this.onDataChange("meterperiod", e.target.value)
                      }
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>
                      Следующее ТО
                      <br /> при наработке
                    </label>
                    <input
                      id="metervalue"
                      value={data.metervalue || ""}
                      onChange={(e) =>
                        this.onDataChange("metervalue", e.target.value)
                      }
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="form-group">
                    <label>
                      Период ТО
                      <br /> по календарю
                    </label>
                    <SuperSelect
                      defaultValue={data.schedulerid}
                      onChange={(value) =>
                        this.onDataChange("schedulerid", value)
                      }
                      essence="scheduler"
                      placeholder="Выберите расписание..."
                      nameField="name"
                      idField="id"
                      isClearable
                      reference={{
                        title: "Расписания",
                        essence: "scheduler",
                        showDescription: true,
                        showType: true,
                        itemEditor: (itemEditorProps) => (
                          <EssenceReferenceSchedulerEdit {...itemEditorProps} />
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group">
                    <label>
                      Дата наступления
                      <br /> следующего ТО
                    </label>
                    <DtPicker
                      isClearable
                      onChange={(v) => this.onDataChange("daterun", v)}
                      value={data.daterun}
                      time
                    />
                  </div>
                </div>
              </div>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th width="35%">
                    <i
                      title="Добавить строку"
                      onClick={() => this.rowAdd()}
                      className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                    ></i>
                    Процедура
                  </th>
                  <th width="35%">Требуется</th>
                  <th width="10%">Кол-во</th>
                  <th width="20%">Eд. изм.</th>
                </tr>
              </thead>
              <tbody>
                {lines.map((item, idx) => {
                  let line = item || {};
                  return (
                    <tr key={idx}>
                      <td>
                        <ElasticInput
                          rows={1}
                          value={item.name || ""}
                          onChange={(e) =>
                            this.onLineChange(idx, "name", e.target.value)
                          }
                          className="form-control"
                        />
                        {/*
                          <div className="d-flex align-items-center">
                            <div className="input-group">
                              <input
                                className="form-control"
                                value={item.name || ""}
                                onChange={(e) =>
                                  this.onLineChange(idx, "name", e.target.value)
                                }
                              />
                              <div className="input-group-append">
                                <button
                                  title="Описание процедуры"
                                  className="btn btn-icon border"
                                  type="button"
                                  onClick={() => this.descriptionToggle(idx)}
                                >
                                  <i className="fa fa-list"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                              */}
                        {descriptionOpen === idx && (
                          <BsModal
                            show
                            center
                            onClose={() => this.descriptionToggle(idx)}
                          >
                            <textarea
                              style={{ minHeight: "350px" }}
                              className="form-control"
                              value={item.description || ""}
                              onChange={(e) =>
                                this.onLineChange(
                                  idx,
                                  "description",
                                  e.target.value
                                )
                              }
                            />
                          </BsModal>
                        )}
                      </td>
                      <td>
                        <div className="input-group">
                          <input
                            readOnly
                            type="text"
                            className="form-control"
                            placeholder="ЗИП"
                            value={this.getModelLabel(line.modelid)}
                            onDoubleClick={() => this.onModelPickOpen(idx)}
                          />
                          <div className="input-group-append">
                            <button
                              title="Выбрать"
                              className="btn btn-icon border"
                              type="button"
                              onClick={() => this.onModelPickOpen(idx)}
                            >
                              <i className="fa icon-md text-muted fa-navicon"></i>
                            </button>
                          </div>
                        </div>

                        {/*
                        <CreatableSelect
                          value={this.context.api.getReferenceValue(
                            line.modelid,
                            this.state.models
                          )}
                          onChange={(result) =>
                            this.onLineChange(
                              idx,
                              "modelid",
                              result ? result.value : null
                            )
                          }
                          onCreateOption={(value) =>
                            this.onCreateModel(idx, "modelid", value)
                          }
                          className="from-control react-select"
                          classNamePrefix="react-select-inner"
                          options={this.state.models}
                          placeholder="..."
                          noOptionsMessage={({ inputValue }) =>
                            `Ничего не найдено по запросу ${inputValue}`
                          }
                          formatCreateLabel={(inputValue) =>
                            `Добавить: ${inputValue}`
                          }
                          filterOption={this.context.api.filterOption}
                          isClearable
                        />*/}
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={item.volume || ""}
                          size={3}
                          type="number"
                          onChange={(e) =>
                            this.onLineChange(idx, "volume", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <Select
                              value={this.context.api.getReferenceValue(
                                line.measureid,
                                this.state.measure
                              )}
                              onChange={(result) =>
                                this.onLineChange(
                                  idx,
                                  "measureid",
                                  result ? result.value : null
                                )
                              }
                              className="from-control react-select"
                              classNamePrefix="react-select-inner"
                              options={this.state.measure}
                              placeholder="..."
                              noOptionsMessage={({ inputValue }) =>
                                `Ничего не найдено по запросу ${inputValue}`
                              }
                              isClearable
                            />
                          </div>
                          <div className="ml-3 text-nowrap">
                            <i
                              title="Удалить строку"
                              onClick={() => this.rowRemove(idx)}
                              className="fa fa-times cursor-pointer text-hover-danger "
                            ></i>
                            <i
                              title="Добавить строку ниже"
                              onClick={() => this.rowAdd(idx + 1)}
                              className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                            ></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {this.props.manageMaint && (
              <>
                <div className="mb-4 py-2 border-bottom"></div>
                <div className="d-flex justify-content-between">
                  <div>
                    <button onClick={this.save} className="btn btn-primary">
                      Сохранить
                    </button>
                  </div>
                  <div></div>
                </div>
              </>
            )}
          </Blocker>
        </Modal>
      </>
    );
  }
}
